import { styled } from 'stitches.config'

export const CircledIconRoot = styled('div', {
  backgroundColor: '$tertiary-200',
  size: '$12',
  color: '$accent-black',
  border: '2px solid $primary-700',
  borderRadius: '$round',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
